import React from "react";

const Auth = React.lazy(() => import("../views/Auth/index"));
const SettingsView = React.lazy(() => import("../views/Settings/index"));
const OauthCallBackView = React.lazy(() =>
  import("../views/OauthCallbacks/index")
);
const PortalsView = React.lazy(() => import("../views/Portals/index"));
const MainSettingsView = React.lazy(() => import("../views/MainSettings/index.jsx"));
const DatabaseView = React.lazy(() => import("../views/Database/index"));
const WorkflowsView = React.lazy(() => import("../views/Workflows/index"));
const LayoutView = React.lazy(() => import("../views/Layout/index"));
const DashboardView = React.lazy(() => import("../views/Dashboard/index"));
const RequestsView = React.lazy(() => import("../views/Requests/index"));
const ReleasesView = React.lazy(() => import("../views/Releases/index"));
const ReleaseDocumentView = React.lazy(() => import("../views/ReleaseDocument/index"));
const RequestDocumentView = React.lazy(() => import("../views/RequestDocument/index"));
const ClientUserAuthenticationView = React.lazy(() =>
  import("../views/ClientUserAuthentication/index")
);
const ClientUserInfoView = React.lazy(() =>
  import("../views/ClientUserAuthentication/customerInfo")
);
const IntegrationsView = React.lazy(() =>
  import("../views/Integrations/index")
);
const WhatsappIntegrationView = React.lazy(() =>
  import("../views/Integrations/whatsapp/index")
);
const CreateWorkspaceView = React.lazy(() =>
  import("../views/Workspace/CreateWorkspace/index")
);
const CreatePortalView = React.lazy(() =>
  import("../views/Portals/CreatePortal/index")
);

const routes = {
  auth: {
    path: "/auth",
    component: Auth,
    roles: [],
    exact: false,
    leftNavigationType: null,
    routes: {
      login: {
        exact: true,
        path: "/login",
      },
      register: {
        exact: true,
        path: "/register",
      },
    },
  },
  settings: {
    path: "/settings",
    component: MainSettingsView,
    leftNavigationType: null,
    roles: ["USER"],
    exact: false,
  },
  portalSettings: {
    path: "/:portalSlug/settings",
    component: SettingsView,
    leftNavigationType: "portalNav",
    roles: ["USER"],
    exact: false,
  },
  oauthCallbacks: {
    path: "/oauthCallback",
    leftNavigationType: null,
    component: OauthCallBackView,
    roles: [],
    exact: false,
  },
  portals: {
    path: "/portals",
    leftNavigationType: null,
    component: PortalsView,
    roles: ["USER"],
    exact: true,
  },
  noWorkflow: {
    path: "/:portalSlug/workflows",
    leftNavigationType: "portalNav",
    component: WorkflowsView,
    roles: ["USER"],
    exact: true,
  },
  workflows: {
    path: "/:portalSlug/workflows/:workflowSlug",
    leftNavigationType: "portalNav",
    component: WorkflowsView,
    roles: ["USER"],
    exact: true,
  },
  layout: {
    path: "/:portalSlug/layout",
    leftNavigationType: "portalNav",
    component: LayoutView,
    roles: ["USER"],
    exact: true,
  },
  dashboard: {
    path: "/:portalSlug/dashboard",
    leftNavigationType: "portalNav",
    component: DashboardView,
    roles: ["USER"],
    exact: true,
  },
  requests: {
    path: "/:portalSlug/requests",
    leftNavigationType: "portalNav",
    component: RequestsView,
    roles: ["USER"],
    exact: true,
  },
  releases: {
    path: "/:portalSlug/releases",
    leftNavigationType: "portalNav",
    component: ReleasesView,
    roles: ["USER"],
    exact: true,
  },
  document: {
    path: "/:portalSlug/releases/document/:documentId",
    leftNavigationType: "portalNav",
    component: ReleaseDocumentView,
    roles: ["USER"],
    exact: true,
  },
  feedback: {
    path: "/:portalSlug/requests/feedback/:feedbackId",
    leftNavigationType: "portalNav",
    component: RequestDocumentView,
    roles: ["USER"],
    exact: true,
  },
  database: {
    path: "/:portalSlug/database",
    leftNavigationType: "portalNav",
    component: DatabaseView,
    roles: ["USER"],
    exact: false,
  },
  community: {
    path: "/:portalSlug/community",
    leftNavigationType: "portalNav",
    component: ClientUserAuthenticationView,
    roles: ["USER"],
    exact: true,
  },
  customerInfo: {
    path: "/:portalSlug/customer/:customerId",
    leftNavigationType: "portalNav",
    component: ClientUserInfoView,
    roles: ["USER"],
    exact: false,
  },
  // customerVariables: {
  //   path: "/:portalSlug/customer/:customerId/variables",
  //   leftNavigationType: "portalNav",
  //   component: ClientUserAuthenticationView,
  //   roles: ["USER"],
  //   exact: true,
  // },
  whatsappIntegration: {
    path: "/:portalSlug/integrations/whatsapp",
    leftNavigationType: "portalNav",
    component: WhatsappIntegrationView,
    roles: ["USER"],
    exact: false,
  },
  integrations: {
    path: "/:portalSlug/integrations",
    leftNavigationType: "portalNav",
    component: IntegrationsView,
    roles: ["USER"],
    exact: false,
  },
  workspaceCreate: {
    path: "/workspace/create",
    component: CreateWorkspaceView,
    roles: ["USER"],
    exact: false,
  },
  portalCreate: {
    path: "/portal/create",
    component: CreatePortalView,
    roles: ["USER"],
    exact: false,
  },
};

export default routes;
